import m from "mithril";
import { BlueBackground } from "./components/BlueBackground";
import { Copyright } from "./components/Copyright";
import { TinyLoadingAnimationCenter } from "./components/LoadingAnimation";
import { LogoWithText } from "./components/LogoWithText";
import { PrimaryButton } from "./components/PrimaryButton";
import { Text } from "./components/Text";
import { PasswordField } from "./components/TextField";
import { TextLink } from "./components/TextLink";

let newPassword = "";
let confirmPassword = "";
let error = "";
let isLoading = false;
let isSuccess = false;
let appUrl = "";

const doChangePassword = async () => {
  // eslint-disable-next-line no-console
  console.log("do change password");
  error = "";

  if (newPassword !== confirmPassword) {
    error = "Passwords do not match";

    return;
  }

  isLoading = true;
  const res = await m.request<{ success: boolean; error: string; redirectUrl: string }>({
    method: "POST",
    url: "/auth/useraccount/passwordchange",
    body: { newPassword },
  });

  isLoading = false;

  if (res.success) {
    isSuccess = true;
    appUrl = res.redirectUrl;

    window.setTimeout(() => {
      window.location.href = res.redirectUrl;
    }, 1000);
  } else {
    error = res.error || "An unknown error occurred";
    // eslint-disable-next-line no-console
    console.log("failed");
    // eslint-disable-next-line no-console
    console.log(res);
  }
};

export const ChangePasswordPage: m.Component = {
  view() {
    return m(
      BlueBackground,
      m("div.flex.justify-center.pt-4.pb-3", m(LogoWithText)),
      m(
        "div.w-96.space-y-3.mx-auto.bg-white.text-slate-600.rounded-lg.p-8",
        m("div.text-center", m(Text, { variant: "subtitle" }, "PASSWORD CHANGE REQUIRED")),
        m(
          "div.pb-2",
          m(Text, { variant: "hint" }, m("span.font-bold", "You must change your password to continue.")),
          m(Text, { variant: "hint" }, "Please choose a new password to continue accessing your account.")
        ),
        m(
          "div.space-y-1",
          m(
            "div",
            m(Text, { variant: "label" }, "New Password"),
            m(PasswordField, {
              value: newPassword,
              focus: true,
              placeholder: "Enter New Password...",
              autocomplete: "off",
              onValue: (value) => {
                newPassword = value;
              },
            })
          ),
          m(
            "div",
            m(Text, { variant: "label" }, "Confirm New Password"),
            m(PasswordField, {
              value: confirmPassword,
              placeholder: "Confirm Password...",
              autocomplete: "off",
              onValue: (value) => {
                confirmPassword = value;
              },
            })
          )
        ),
        error && m(Text, { variant: "error" }, error),
        m(
          PrimaryButton,
          {
            disabled: !confirmPassword || !newPassword || !confirmPassword || isLoading || isSuccess,
            onclick() {
              doChangePassword();
            },
          },
          isLoading ? m(TinyLoadingAnimationCenter) : "Change Password & Continue"
        ),
        isSuccess &&
          m(
            "div.space-y-2.text-center",
            m(Text, { variant: "hint" }, "Password changed successfully, continue"),
            m(
              Text,
              { variant: "hint" },
              m(
                "div.flex.items-center.justify-center",

                m(
                  TextLink,
                  {
                    onclick() {
                      if (!appUrl) {
                        error = "No redirect URL received";

                        return;
                      }

                      window.location.href = appUrl;
                    },
                  },
                  "going to Doublefin app"
                )
              )
            )
          )
      ),
      m("div.mt-6", m(Copyright))
    );
  },
};
